import React from "react";
import { Card, Icon, Label } from "semantic-ui-react";
import moment from "moment";
import { useHistory } from "react-router-dom";

const QRPatientCard = ({ el, qrSearch }) => {
	let history = useHistory();

	const goToHome = (element) => {
		if (element.safeplace || element.campaign) {
			qrSearch(element.qr_code);
		}
		if (element.preregister) {
			qrSearch(element);
		}

		history.push("/home/lab");
	};
	return (
		<Card key={el.qr_code} style={{ margin: "10px" }} onClick={() => goToHome(el)}>
			<Card.Content>
				{el.safeplace && (
					<Label attached="top" color="orange">
						Safeplace
					</Label>
				)}
				{el.preregister && (
					<Label attached="top" color="violet">
						Pré-inscription
					</Label>
				)}
				{el.campaign && (
					<Label attached="top" color="yellow">
						Campagne de prélèvement
					</Label>
				)}
				<Card.Header style={{ fontSize: "0.9em" }}>
					{el.gender === "male" ? "(M)" : "(F)"} {el.birth_name} {el.last_name} {el.first_name}
				</Card.Header>
				<Card.Meta style={{ fontSize: "0.8em" }}>
					{el.matricule && (
						<div>
							<Icon name="id card" /> {el.matricule}
						</div>
					)}
				</Card.Meta>
				<Card.Description style={{ fontSize: "0.8em" }}>
					<div>
						<Icon name="phone" /> : {el.mobile_phone}{" "}
					</div>
					<div>
						<Icon name="at" /> : {el.email}{" "}
					</div>
					<div>
						<Icon name="birthday" /> :{" "}
						{el.birth_date && new RegExp("^(0?[1-9]|[12][0-9]|3[01])[/](0?[1-9]|1[012])[/]([1-9]{1}[0-9]{3})$").test(el.birth_date.toString())
							? moment(el.birth_date, "DD/MM/YYYY").format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)
							: moment(el.birth_date).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}{" "}
					</div>
					<div>
						<Icon name="qrcode" /> : {el.qr_code}{" "}
					</div>
				</Card.Description>
			</Card.Content>

			<Card.Content extra>
				<span style={{ fontSize: "0.8em" }} className="date">
					{el.safeplace ? "Payé" : "Reçu"} le{" "}
					{moment(el.safeplace ? el.creation_date : el.created_at).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)} à{" "}
					{moment(el.safeplace ? el.creation_date : el.created_at).format(process.env.REACT_APP_TIME_DISPLAY_FORMAT)}
				</span>
			</Card.Content>
		</Card>
	);
};

export default QRPatientCard;
